"use client";

import { useEffect } from "react";
import { logClientError } from "@/lib/client-error";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    logClientError(error, "Global React error");
  }, [error]);

  // This boundary replaces the root layout, so it renders raw HTML with a
  // neutral gray palette instead of app components/tokens.
  return (
    <html>
      <body className="p-8 font-sans">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">Критическая ошибка</h2>
        {error.digest && (
          <p className="text-sm text-gray-500 mb-2">
            <span className="font-medium">Digest:</span> {error.digest}
          </p>
        )}
        {error.message && (
          <pre className="bg-gray-100 rounded p-4 text-sm whitespace-pre-wrap break-all mb-4">
            {error.message}
          </pre>
        )}
        {error.stack && (
          <pre className="bg-gray-100 rounded p-4 text-xs whitespace-pre-wrap break-all mb-6 text-gray-500">
            {error.stack}
          </pre>
        )}
        <button
          onClick={reset}
          className="px-4 py-2 rounded bg-gray-800 text-white text-sm"
        >
          Попробовать снова
        </button>
      </body>
    </html>
  );
}
